import type { ReactNode } from "react";

import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

import type { FilterField } from "./filter-toolbar/types";
import type { DataTableColumn, DataTableInstance } from "./table-features";

import { HeaderFilterPopover } from "./filter-toolbar/header-filter-popover";
import styles from "./sort-header.module.css";

export function SortHeader<T>({
  column,
  sortable,
  filter,
  children,
}: {
  column?: DataTableColumn<T>;
  sortable: boolean;
  /** When set, renders a funnel button that opens this column's filter editor in a popover. */
  filter?: { table: DataTableInstance<T>; field: FilterField<T> };
  children: ReactNode;
}) {
  const filterIcon = filter && (
    <HeaderFilterPopover
      table={filter.table}
      field={filter.field}
      triggerClassName={styles.filterTrigger}
    />
  );

  if (!sortable || !column) {
    return (
      <span className={styles.header}>
        {filterIcon}
        <b>{children}</b>
      </span>
    );
  }

  const sorted = column.getIsSorted();

  return (
    <span
      className={`${styles.header} ${styles.sortable}`}
      onClick={() => column.toggleSorting(undefined, false)}
    >
      {filterIcon}
      <b>{children}</b>
      <span
        className={`${styles.icon} ${sorted ? styles.active : styles.inactive}`}
      >
        {!sorted ? (
          <ArrowUpDown size={14} />
        ) : sorted === "asc" ? (
          <ArrowUp size={14} />
        ) : (
          <ArrowDown size={14} />
        )}
      </span>
    </span>
  );
}
